import { bootstrapApplication } from '@angular/platform-browser';
import { enableDevValidations } from 'ag-grid-community';

import { AppComponent } from '@app/app.component';
import { appConfig } from '@app/app.config';
import { environment } from '@environments/environment';

// Debug mode for App Check (recaptcha) in development/nonprod
declare global {
  var FIREBASE_APPCHECK_DEBUG_TOKEN: string | boolean | undefined | null;
}

if (!environment.production) {
  // AG Grid 36+: ValidationModule is no longer in AllCommunityModule.
  enableDevValidations();

  if (environment.appCheck?.debug?.token) {
    (self as any).FIREBASE_APPCHECK_DEBUG_TOKEN =
      environment.appCheck.debug.token;
  }
}

bootstrapApplication(AppComponent, appConfig);
